import { Link } from "react-router-dom";
import { t } from "../constants/i18n";
import type { Lang } from "../constants/i18n";
import { LAB_HOST, SITE } from "../constants/domains";
import "./Footer.css";

interface FooterProps {
  lang: Lang;
}

export default function Footer({ lang }: FooterProps) {
  return (
    <footer>
      <div className="container">
        <div className="footer">
          <span className="footer-left">
            {t(lang, "footer_made")} <a href={SITE.main}>sp4r0ww</a>
          </span>
          <div className="footer-right">
            <Link className="footer-legal" to={`${SITE.legal}/`}>
              {t(lang, "footer_legal")}
            </Link>
            <span className="footer-domain">© 2026 sp4r0ww • {LAB_HOST}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
